module.exports = __webpack_public_path__ + "img/profile_box_foot_way_right.cc78a32b.svg";